import React from "react";
import { Panel, Overline } from "./Panel";

export function StatCard({ icon: Icon, label, value, unit, accent = "var(--accent)", sub, testid }) {
  return (
    <Panel hover className="p-4 sm:p-6 fade-up" data-testid={testid}>
      <div className="flex items-start justify-between">
        <Overline>{label}</Overline>
        <div
          className="w-8 h-8 sm:w-9 sm:h-9 rounded-md flex items-center justify-center shrink-0"
          style={{ background: "var(--accent-soft)", color: accent }}
        >
          <Icon size={16} strokeWidth={2.2} />
        </div>
      </div>
      <div className="mt-3 sm:mt-5 flex items-baseline gap-1.5">
        <span className="font-mono font-medium text-2xl sm:text-4xl tracking-tight tabular-nums" style={{ color: accent }} data-testid={`${testid}-value`}>
          {value}
        </span>
        {unit && <span className="font-mono text-xs sm:text-sm text-[var(--t2)]">{unit}</span>}
      </div>
      {sub && <div className="mt-1 text-xs text-[var(--t2)] font-mono">{sub}</div>}
    </Panel>
  );
}
